import {restfulApiClient} from "./api.ts";

export const instructions = {
    async get() {
        return await restfulApiClient.get("instructions", 1);
    },
}